import { setRuntimeBranding } from 'config/brand';
import { useSyncExternalStore } from 'react';
import {
  getPlatformPublicProfile,
  type PlatformPublicProfile,
} from '@/modules/platform-management/services/platform-settings.api';

export type PlatformProfileState = {
  loaded: boolean;
  aiAssistantEnabled: boolean;
  version: number;
};

let state: PlatformProfileState = {
  loaded: false,
  aiAssistantEnabled: true,
  version: 0,
};
const listeners = new Set<() => void>();

export const applyPlatformProfile = (
  profile: Partial<PlatformPublicProfile>,
): void => {
  if (profile.branding) {
    setRuntimeBranding(profile.branding);
  }
  state = {
    loaded: true,
    aiAssistantEnabled:
      profile.features?.aiAssistantEnabled ?? state.aiAssistantEnabled,
    version: state.version + 1,
  };
  for (const listener of listeners) listener();
};

export const loadPlatformProfile = async (): Promise<void> => {
  try {
    applyPlatformProfile(await getPlatformPublicProfile());
  } catch {
    // 拉取失败沿用缓存或环境变量里的品牌，不阻断应用启动
  }
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

const getSnapshot = () => state;

export const usePlatformProfile = (): PlatformProfileState =>
  useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
